module.exports = __webpack_public_path__ + "b8b2cf196aec72689595a789365ac7e0.png";